"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeeklyReportSchema = exports.ReportSchema = exports.ReportType = void 0;
const luxon_1 = require("luxon");
const zod_1 = require("zod");
const item_1 = require("../item");
const plan_1 = require("../plan");
const store_1 = require("../store/store");
const user_1 = require("../user");
var ReportType;
(function (ReportType) {
    ReportType["Daily"] = "DAILY";
    ReportType["Weekly"] = "WEEKLY";
    ReportType["Monthly"] = "MONTHLY";
    ReportType["Yearly"] = "YEARLY";
})(ReportType || (exports.ReportType = ReportType = {}));
exports.ReportSchema = zod_1.z.object({
    type: zod_1.z.nativeEnum(ReportType),
    startsAt: zod_1.z.coerce.date().transform((date) => luxon_1.DateTime.fromJSDate(date)),
    endsAt: zod_1.z.coerce.date().transform((date) => luxon_1.DateTime.fromJSDate(date)),
    store: store_1.StoreSchema.pick({
        id: true,
        name: true,
        profileImageUri: true,
        locale: true,
        timeZone: true,
        currentContract: true,
        owner: true,
        whatsappPhoneNumber: true,
    }).extend({
        currentContract: plan_1.ContractSchema.pick({
            id: true,
            planType: true,
            status: true,
        }),
        owner: user_1.UserSchema.pick({
            id: true,
            name: true,
            email: true,
        }),
    }),
});
exports.WeeklyReportSchema = exports.ReportSchema.extend({
    type: zod_1.z.literal(ReportType.Weekly),
    week: zod_1.z.string().optional(),
    storefront: zod_1.z.object({
        visits: zod_1.z.number().min(0),
        generatedLeads: zod_1.z.number().min(0),
        visitedItems: zod_1.z.number().min(0),
    }),
    items: zod_1.z.object({
        created: zod_1.z.number().min(0),
        noSalesInLast60Days: zod_1.z.number().min(0),
        outOfStock: zod_1.z.number().min(0),
        lowStock: zod_1.z.number().min(0),
        missingPrice: zod_1.z.number().min(0),
        missingPictures: zod_1.z.number().min(0),
    }),
    highlights: zod_1.z.object({
        mostVisitedItems: zod_1.z
            .object({
            item: item_1.ItemSchema.pick({ id: true, pictures: true }).extend({
                baseVariant: item_1.ItemVariantSchema.pick({ title: true }),
            }),
            visits: zod_1.z.number().min(0),
        })
            .array(),
    }),
});
//# sourceMappingURL=report.js.map